export default __webpack_public_path__ + "static/media/MWC-Services_Start.57f8c482.jpg";